import { render } from "./SettingFileEdit.vue?vue&type=template&id=1c57f1c2"
import script from "./SettingFileEdit.vue?vue&type=script&lang=js"
export * from "./SettingFileEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__